import type { ReactNode } from "react"

interface AuthShellProps {
  children: ReactNode
  description: string
  title: string
}

export function AuthShell({
  children,
  description,
  title,
}: AuthShellProps) {
  return (
    <div className="min-h-svh px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto flex w-full max-w-xl flex-col items-center gap-6 pt-8 sm:pt-16">
        <div className="text-center space-y-3">
          <h1 className="font-heading text-3xl leading-tight tracking-tight sm:text-4xl">
            {title}
          </h1>
          <p className="text-base leading-7 text-muted-foreground">
            {description}
          </p>
        </div>
        {children}
      </div>
    </div>
  )
}
